import { Location } from '@freelancer/location';
import { finalize, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../location/location.service";
import * as i2 from "./login.config";
var LogoutGuard = /** @class */ (function () {
    function LogoutGuard(location, authService) {
        this.location = location;
        this.authService = authService;
    }
    LogoutGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        return this.authService.isLoggedIn().pipe(map(function (isLoggedIn) {
            var next = route.queryParams.next;
            // already logged out - just progress to next/homepage
            if (!isLoggedIn) {
                _this.location.navigateByUrl(next || '/');
                return false;
            }
            _this.authService
                .logout()
                .pipe(finalize(function () { return _this.location.navigateByUrl(next || '/'); }))
                .toPromise();
            return true;
        }));
    };
    LogoutGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LogoutGuard_Factory() { return new LogoutGuard(i0.ɵɵinject(i1.Location), i0.ɵɵinject(i2.LOGIN_AUTH_SERVICE)); }, token: LogoutGuard, providedIn: "root" });
    return LogoutGuard;
}());
export { LogoutGuard };
